import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage, RegisterPage, InfoPage, UserManagementPage, ProgramManagementPage, ClassesPage } from './components/pages';
import DashboardLayout from './components/templates/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import GlobalStyles from './styles/GlobalStyles';
import { useAuthListener } from './hooks/useAuthListener';
import { USER_TYPES } from './constants';

function App() {
  // Firebase 인증 상태 감지
  useAuthListener();

  return (
    <BrowserRouter>
      <GlobalStyles />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Dashboard Routes with Layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* 기본 대시보드 경로는 /info로 리다이렉트 */}
          <Route index element={<Navigate to="/dashboard/info" replace />} />

          {/* 정보 페이지 - 모든 인증된 사용자 접근 가능 */}
          <Route path="info" element={<InfoPage />} />

          {/* 프로그램 관리 페이지 - teacher와 admin만 접근 가능 */}
          <Route
            path="programs"
            element={
              <ProtectedRoute requiredTypes={[USER_TYPES.ADMIN, USER_TYPES.TEACHER]}>
                <ProgramManagementPage />
              </ProtectedRoute>
            }
          />

          {/* 수업 관리 페이지 - teacher와 admin만 접근 가능 */}
          <Route
            path="classes"
            element={
              <ProtectedRoute requiredTypes={[USER_TYPES.ADMIN, USER_TYPES.TEACHER]}>
                <ClassesPage />
              </ProtectedRoute>
            }
          />

          {/* 회원관리 페이지 - admin만 접근 가능 */}
          <Route
            path="users"
            element={
              <ProtectedRoute requiredType={USER_TYPES.ADMIN}>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
